import { Meal, Product } from '../../types';

export function isMealItem(item: Product | Meal): item is Meal {
  return 'courseMealChoices' in item;
}
